module.exports = __webpack_public_path__ + "img/third_place.2cb08153.png";